import Dealership from "./Dealership";

export default Dealership;
